import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoQuizQuestion } from "@/shared/model/edo-quiz-question.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-quiz-question.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface IRemoveQuestionProps {
  question: IEdoQuizQuestion;
  open: boolean;
  onClose: () => void;
}

const RemoveQuestion = (props: IRemoveQuestionProps) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector<EntityState<IEdoQuizQuestion>>(
    (state) => state.edoQuizQuestion
  );

  const { question, open, onClose: handleClose } = props;

  const confirmRemove = () => {
    dispatch(deleteEntity(question.id));
  };

  useEffect(() => {
    if (open && updateSuccess) {
      handleClose();
    }
  }, [updateSuccess, open, handleClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate contentKey="edocendoApp.edoQuizQuestion.delete.question">
            Are you sure you want to delete this EdoQuizQuestion?
          </Translate>
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmRemove}>
            <Translate contentKey="entity.action.delete">Remove</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveQuestion;
